// src/utils/http.js
import axios from 'axios'
import router from '@/router' // 如果你暂时没用 vue-router，可以先删掉相关代码
import { getExistingWsClient } from '@/utils/wsInstance'
const service = axios.create({
  baseURL: 'https://api-partner.iavcms.com', // 后端地址，看你实际情况改
  timeout: 10000
})

// 请求拦截：自动带上 token
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      // 跟后端约定好的 Header
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截：统一处理 code / message
service.interceptors.response.use(
  response => {
    const res = response.data
    // 后端统一结构：{ code, message, data }

    // 登录态异常（拦截器返回的 401）
    if (res.code === 401) {
      // ✅ 关闭 WebSocket 连接
      // const wsClient = getExistingWsClient()
      // if (wsClient && wsClient.ws) {
      //   try {
      //     wsClient.ws.close(4001, 'Invalid token')
      //     console.warn('⚠️ 已关闭 WebSocket 连接（token 失效）')
      //   } catch (e) {
      //     console.error('❌ 关闭 WebSocket 出错:', e)
      //   }
      // }

      // 清掉本地 token
      localStorage.clear()
      // 这里可以根据你实际路由调整
      if (router) {
        router.push('/login')
      }
      // 给调用者一个 reject，方便页面提示
      // return Promise.reject(new Error(res.message || '未登录'))
    }

    // 业务失败（你自己定义：code != 0）
    if (res.code !== 0) {
      // 这里可以加全局 message 提示，比如 element-ui 的 Message
      // Message.error(res.message || '请求失败')
      return res
    }

    // 正常返回 data 部分，调用方拿的就是 data
    return res
  },
  error => {
    if (error.response && error.response.status === 401) {

      // const wsClient = getExistingWsClient()
      // if (wsClient && wsClient.ws) {
      //   try {
      //     wsClient.ws.close(4001, 'Invalid token')
      //     console.warn('⚠️ 已关闭 WebSocket 连接（token 失效）')
      //   } catch (e) {
      //     console.error('❌ 关闭 WebSocket 出错:', e)
      //   }
      // }

      localStorage.clear()
      router.push('/login')
      return Promise.reject(error)
    }

    return Promise.reject(error)
  }
   
)

export default service
